import * as BBApi from '..';

const rootUrl = BBApi.host + '/cms/images/';

export const query = async (searchText: string = '') => {
	const url = new URL(rootUrl);
	url.searchParams.append('search', searchText);

	const response = await BBApi.get(url.href);
	const images = await response.json();
	return images;
};

export const create = async (imageCreate: any) => {
	const base64PrefixPattern = /data:image\/\w+;base64/;
	const imageSource = imageCreate.imageSource.replace(base64PrefixPattern, '');
	imageCreate.imageSource = imageSource;

	await BBApi.post(rootUrl, imageCreate);
};

export const remove = async (imageName: string) => {
	await BBApi.del(rootUrl + imageName);
};
